const { MerkleTree } = require('merkletreejs');
const keccak256 = require('keccak256');
const { ethers } = require("ethers");
const Web3 = require("web3");

const web3 = new Web3();









let whitelistAddresses = [
    
    {
        address: "0x367016A97656C785305eB42B692A3B9601B48E4c",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x9b95d8f7c44efc92B03ae2f17E2344E67de04F96",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x4C1dD1f078e78935DFD83F27f3A254b3E7d5E21a",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xf79f18C17429A6990448BDfc5fB744eF4EEc3cA2",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xA92bf68D0B966342d6ECA83ea99f99854f460a0B",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x7A92Ce5cbb4dE04AAC45b59FAA8ee1f82a378ab4",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xbbD005bB643166de57499958f8856250A736C8e0",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xBA67fE339e1CEe8eFD1504A9d2EB48a62828e4d7",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x21f055920EE3eC1a0123BB5587A063907B6a0f9d",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x1954e9bE7E604Ff1A0f6D20dabC54F4DD86d8e46",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xA347BD0722dA25D6673EEF56a16D922022c8FD3A",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xD64482815C75bF1D017a5c1D0D2818DBB08D4c97",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xa42672dfa6b0d41c20d6742f5f872426241beef1",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xa10E584741A09C9BBE44C56a2041bb2eb99CCd91",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xF2fB19211566e5Fc9Ace37b987364cfb004CAEd2",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xABA4414Cc3bc819268dFdd14a8e5DA2300443aa1",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xb943f122Aee5dD57C17aB2Df74917f5744162c68",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xe36410a9E0B5e4E0F8839FE261cf2dEab37254f5",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x011AFdbe72a4c1Da8FC9d62d69eEfE685022380B",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x01DBb1C32aEcB0D206538F524fc260556b7fa2C8",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x0f762865cfe9856f16194c1a64397b5f67c7e0c3",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x126F87315a639e6dd3725681a8B26f1112291985",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x145Fa8121905163003eF699e39929a1FD127565F",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x16D534672957E9FeA8005a32676f760bcF591bc9",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x173a32983e78Ab434A625d8e8174cbB084ebeF0d",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x1b36f49A31B519aa1D1EDbD09B3368438C2030A9",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x1bc16F4BB0f2685a49BCA4589C37ba699ED5fB9E",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x1c54f6670bBB38C4e9782E196c508252BF065217",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x1ffDE413d99D87097783d61C8118113Ea19c3A0f",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x20589349B25de6E4b3682d8c80f40EfddE5B4928",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x207B6249E494EA37bb87973e6F677285430c605A",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x20bb3f80a00341B40f8A90A787b31D575FBC4240",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x24636f90d018310d37258C24Bdc71e824A6Ae014",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x24d6A08074821aA01d47b1b56B4a75016953E556",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x282b7Be730c33F784207C3122A26be1B378372c6",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x2BEC20F4d9EE8b957D9E86BBD17C88240b894454",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x2D97479f0E199dda6C30Fb6e2dDE9ab79BF27506",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x2E09847b0539a2C7B5676A0BacD2E749E561e85b",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x2f8dCE6A4cAE85d9DE3D56E49D8E766809C7f22D",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x2ff0555d00991a194aEcc7C3f26B01A08EE5be0B",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x2FFb3aA4359be1DAa675E13882F24a530cF273f9",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x30faC264384582Fe99411c4D893F7e0b838708DA",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x32FE9Ae3E7eab817B26D13E131B91ebfb514a9CC",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x35b863978CF0DD809fc8451ffEdC937b49f871d0",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x390bADA9069313333774f6e876BBC2057D018037",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x390bADA9069313333774f6e876BBC2057D018037",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x3baD58514a98FCdbA7ac0B010a0554E3d724f031",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x3c6a7aa90CEcD29C274F82f92c64Bf4937c001B7",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x3f44E32E288D3E3B31EC1E7332940729A6eceB33",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x4431fCa445288FCa7e04C4A241c4d3F9fa2D6972",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x4599b60104fd24D099753861416A8bfd9d59fe62",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x46D5d8cC28d4ecFb7455cC73D1749b68a1b403ff",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x49AFE5b2F5Fb12C943E04eC5Bf331Bd2B5E519cB",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5042F5e1822D94dEcAB2215E0A63e1CbA3275109",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x51d4D62951c5D5B7702b82D0132dfC1E4E9adB92",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x51d4D62951c5D5B7702b82D0132dfC1E4E9adB92",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x53bbF8734Ecdc75035a63CA934BA99adE1bE9035",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x541B4aE48410c2E60256f81D3D4E3673780c4327",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5792ad825A8AE7F3a2a8026d527d4cA17A7636c5",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5831e28b78a68F7bfa6a7aD3C36d0E3d2dB6D8Ea",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x592064e0468AF50545e7B8e7f61a0bC24B45C3c4",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x59ce8aebfec9dd73306481bb389cf0e75834a3c1",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5cdaafeaD3952F9a475C0F55Dec2B0A5D4D3c459",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5DFDE2228e0971C4f10A8379e1fbAd7F30D699Fe",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5F353710f6207364D34bE9328406e23Bea5c7191",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5f6712b7D18Bcf9Bdb9EE21C988e23D88Ca75c58",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x62a903e52f4961F0D30c5Be793CbD7C89F737C62",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x644580B17fd98F42B37B56773e71dcfD81eff4cB",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x64B0f2Cc6c0ac0e335c3F4786a5E22fA7978cDAc",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x65c55782A82EEdCd6eecD8339e382E0407B5d12C",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x6C400BC2a0081016F8f0862a76092921913E8328",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x6e7680De49f81968F143Ec8929d62B1b2e3b4c93",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x72F7e66E39a0ecfE99104F0BB4CB06c1eD087cf4",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x73D136a72b8619A0a39E046d987e280E18d1Dabc",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x766D5f2d38589aC4702184199c540cD97565B13B",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x76f59a63731f846301D1a85908f410f034179E75",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x78e99046113307B782B29602521478152c588098",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x813303bf74009452935112522F8cb8e34bC88080",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x8245508E4eeE2Ec32200DeeCD7E85A3050Af7C49",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x857C2f83Fc839b992EF5F04D66e2d141c4dBD33D",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x85D3c6be944F7fF76968C79Fa7CE409F0a3734B6",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x86B76F63BA595a574E8883E8D0924951Cf7cF2c9",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x878bA4295Ee46b2Fc055cB216218d0445a3f1DAF",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x8b6c50979048Db4d9b6C923A705F9C2c603EBeeA",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x8CAe03bAfa928c10be3078Af547bDD83119F2106",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x8cF9ED4E25B17438A63f43F20d7A1A37bb6e3001",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x9066382DDE4d35Db1fB65724BBCedE34743063a9",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x90c0F855979018daBC6b517f39FAddc90Acae292",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x90c0F855979018daBC6b517f39FAddc90Acae292",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x97b271Be070c5509709B2f2E25b0FCe33D10FFE6",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x9a411E67B7497ec169244Ee90C9e9ac49D54292f",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x9AfCD92287CD44c48e627D3eF26dA61616C93d41",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x9e468A8E352ED80BB7e09CB0aB6E49ef77741938",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x9e6d9E6f4617FCcccF8FD8889d1d71a3b4bB2770",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xA16ea3d5919b30418EADDEE23fb4fC171c7C2d62",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xA2d3e8175AeF6bEe7257d0b12A4bd526BfaE2647",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xA2e7F68219ab1c9C88927C01d3E5B4C1920Adb17",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xA508366192c57d7e4810fbf61356e4c3D4DA1610",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xa55a0a3a599B9B6B984A917493791b0F83109F5C",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xAA5448B426b14ed0187d82015fF378b579E8E065",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xB135a21A5d39739438737168C66A9ab3bfD96b6f",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xB5cC3308C8E0F12fCCCa72e0fA3C8C20518c11e7",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xBCcde2FEe7fB10A9A825300e826Ea35fD3f2aF93",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xbe35963934f2e4ec1385acfda3314ae79ee6c58e",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xc55f0572178d6A6217Be36d3f756eF7f5a7F396c",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xc6513B70666C4a682D8FECF16B4D45BB8a2DA534",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xC69523a6fe73056E17E1F346DA66659A6eDDda2A",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xC71656623A6179b6De179b5633D0C7125ecfAc82",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xcb8bA423C495989804fEbCE3CF0535ECb722a484",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xCD2b64d5E8D8Dd5982F430AD6246D4627484c65D",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xCEA431A6f20889670e59e2CEeb5E41Ba0d6d88c3",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xD2c4835269Bb09AdB2CBfFC3A5d5b0E29f62a965",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xd434B922e30193f9181284382517884c94350f9e",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xD4FCA31AC147e89F9E9d6131Bb2B12cE15F1792c",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xD7c38f6274430492CA1a38fA892c85980C8217e5",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xd9709a9454e27496f9849b2c87e597c893513b43",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xdA48bfFAb683506a8aB0CF19D67D54C0c40C89E8",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xEF76c5778C1df746888F84043e3D90005dfCa4f9",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xdC93d75149756B060c431D9DBAa937Da67BDd6E7",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xDD34604Dc4A3E3df248cFa0F29380734DFd10AED",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xE0d58DB97CFB80c1c414369BEC16fFE0467C4d68",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xE264d461b03959308b5AA02B1F5b7DB5439422E7",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xE4796EA5077fdFa78Da5f1176c2B9276259adB57",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xEb1049Ef0D2146123FF3e16F9D851e64d3e8CcF0",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xeCa5D0b717FbC513802Bc809b2F4192EEC1821c6",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xeD5216dE31459d624fDfEA4D37eaa935F93d1ba5",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xedd28e5c0d45dc0eb1c1e902fcbe333fb679dbf3",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xEDe77D1A043a0AAa9Ee2924d26c13696B8bB5a33",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xeE6593620e6743C1B5290397dA9D693A2F6Afa8A",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xeE6593620e6743C1B5290397dA9D693A2F6Afa8A",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xF072a68A14c4a1b312816fD5F38507f8ffc56a72",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xf4205c4716c1ba07838270989ee55ab5eda57276",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xf574EF3aeeFAcc883ca0141F669f81183cb31391",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xF587ADc28a414dbB37BC2d09547a9cd1fF6019F5",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xF5c52688dcE52DA4BeAfacdbB9597ddba09C9E41",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xF763FADc6b52706e6232655484E02fc9099B38AA",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xfbCd56AB1a384e2A42f871E229fc60c92491532b",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xfC6f3a3874c75c887Df42605FA0150b9cdBca81E",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xFc71295AE002b13f024C73c032CC3fF3E149D17b",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5125895efF41756Db02f62d289b7d2b977ec83BC",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xf1f9524f03757be667bc79784ec28b80ff2694fd",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x46d5d8cc28d4ecfb7455cc73d1749b68a1b403ff",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xfbCd56AB1a384e2A42f871E229fc60c92491532b",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x307353A001a0689064AaAf834910efFb1D4C75a9",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x9EC74Bd1bBBB25568dEC5A0293A218c6429930c9",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5125895efF41756Db02f62d289b7d2b977ec83BC",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0xC11778679A4B7be52f63be6b152643549db2C246",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x6C400BC2a0081016F8f0862a76092921913E8328",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },
    {
        address: "0x5610B0AfA7586B9156848D728a64BD8Fbdb7DE96",
        quantity: "1",
        amount: web3.eth.abi.encodeParameter("uint256", "1")
    },

];

const allLower = whitelistAddresses.map((item) => item);

// For each element : concatenate the two hex buffers
// to a single one as this keccak256 implementation only
// expects one input
const leafNodes = allLower.map((item) =>
    keccak256(
        Buffer.concat([
            Buffer.from(item.address.replace("0x", ""), "hex"),
            Buffer.from(item.amount.replace("0x", ""), "hex"),
        ])
    )
);

const merkleTree = new MerkleTree(leafNodes, keccak256, { sortPairs: true });

export async function getProofClaim(address, amount) {
    let index = await allLower.findIndex(
        (item) => item.address.toLowerCase() == address.toLowerCase() && item.amount == amount
    );
    //console.log("this is index", index);
    if (index == -1) {
        return 0;
    }
    //console.log("this is PROOF WOWOOWOWO ", merkleTree.getHexProof(leafNodes[index]));
    return merkleTree.getHexProof(leafNodes[index]);
}

export const getQuantityClaim = async (adress) => {
    for (var i = 0; i < whitelistAddresses.length; i++) {
        console.log(i);
        if (whitelistAddresses[i].address.toLowerCase() == String(adress).toLowerCase()) {
            //console.log("TTT", whitelistAddresses[i].quantity);
            return whitelistAddresses[i].quantity;
        }
    }
}

export async function checkSignatureClaim(adress) {
    let lAdress = adress.toLowerCase();
    let qtt = await getQuantityClaim(lAdress);
    //console.log("qtt", qtt);
    if (!qtt) {
        console.log("gooooooood");
        return false
    }
    const claimingAddress = await keccak256(
        Buffer.concat([
            Buffer.from(lAdress.replace("0x", ""), "hex"),
            Buffer.from(web3.eth.abi.encodeParameter("uint256", qtt).replace("0x", ""), "hex"),
        ])
    );
    const hexProof = await getProofClaim(lAdress, web3.eth.abi.encodeParameter("uint256", qtt));


    let result = await merkleTree.verify(hexProof, claimingAddress, merkleTree.getHexRoot());

    //console.log("hexProof", hexProof);
    //console.log("claimingAddress", claimingAddress);
    //console.log("merkleTree.getHexRoot()", merkleTree.getHexRoot());

    //console.log("check result = ", result);
    return result
}

//checkSignature("0xe36410a9E0B5e4E0F8839FE261cf2dEab37254f5");

// Provide amount as a 32 bytes hex string
/*const proof = getProof(
    "0x5B38Da6a701c568545dCfcB03FcB875f56beddC4",
    web3.eth.abi.encodeParameter("uint256", "2")
);*/

console.log("Root Claim: ", merkleTree.getHexRoot());
// Root :  0x399f97e5a37a31d24b746bb2d8fa5212fbe3c0f7ceb4b69ce3c9f37d0379ff72

//console.log("Proof GG: ", proof);
// Proof :  ['0x15e7001d27767868de62fcb73e3d14ac4d28c60dda34b0f259e79440b8f27e36']
